import React from 'react'
import { usePageView } from 'hooks'
import { getStaticWrapper, mapMediaDocToVideojsObject, THEME } from 'utils'
import { MediaStore } from 'stores/media'
import VideoPlayerLite from 'components/VideoPlayerLite'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import SponsorshipSecondary from 'components/PartnershipsSite/SponsorshipSecondary'
import VideoSection from 'components/PartnershipsSite/VideoSection'
import PhotoQuote from 'components/PartnershipsSite/PhotoQuote'

const BrandedSocialTop = () => {
  const text = [
    'Barstool Sports is the most influential publisher on social with more brands and personalities than anyone else, enabling our partners to connect with a large and diverse audience'
  ]

  const icons = [
    'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
    'https://chumley.barstoolsports.com/union/2021/02/02/snapchat.1ebb2279.png',
    'https://chumley.barstoolsports.com/union/2021/02/02/tik_tok.e6c688ff.png',
    'https://chumley.barstoolsports.com/union/2021/02/02/twitter.7deabcfc.png',
    'https://chumley.barstoolsports.com/union/2021/02/09/ClubHouse-Logo-696x387-1.31c73870.jpg'
  ]

  return (
    <div className='integrationTop'>
      <PhotoQuote
        img={'https://chumley.barstoolsports.com/union/2021/06/08/Branded-Social-Blue.d2defb03.png'}
        text={text}
      />
      <div className='integrationTop__2'>
        <h2>
          Social content on Barstool Sports averages 2B monthly views across Facebook, Twitter, Instagram, Snapchat and
          ClubHouse - and we are now a top 3 publisher on TikTok
        </h2>
        <div className='brandedSocial__icons'>
          {icons.map((src, idx) => (
            <img key={idx} src={src} alt={'icon_' + idx} />
          ))}
        </div>
      </div>
      <style jsx>{`
        .integrationTop__2 {
          text-align: center;
          padding: 40px 0 50px;
        }
        .integrationTop__2 h2 {
          font-size: 0.95rem;
          margin: 0 auto;
          width: 90%;
        }
        .brandedSocial__icons {
          display: flex;
          justify-content: center;
          margin: 25px auto 0;
        }
        .brandedSocial__icons img {
          border-radius: 20%;
          width: 35px;
          height: 35px;
          margin: 0 6px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .integrationTop__2 {
            padding: 30px 0;
          }
          .integrationTop__2 h2 {
            width: 90%;
            margin: auto;
          }
          .integrationTop__info {
            max-width: 48%;
            font-size: 0.75rem;
          }
          .integrationTop__info {
            margin: 35px 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .integrationTop__2 {
            padding: 35px 0;
          }
          .integrationTop__2 h2 {
            width: 600px;
            font-size: 1.2rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .integrationTop__2 {
            padding: 40px 0;
          }
          .integrationTop__2 h2 {
            width: 700px;
            font-size: 1.3rem;
          }
          .brandedSocial__icons {
            margin: 35px auto 0;
          }
          .brandedSocial__icons img {
            width: 40px;
            height: 40px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .integrationTop__2 {
            padding: 45px 0;
          }
          .integrationTop__2 h2 {
            width: 90%;
            font-size: 1.4rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .integrationTop__2 h2 {
            // width: 700px;
            font-size: 1.5rem;
          }
        }
      `}</style>
    </div>
  )
}

const BrandedSocialBottom = ({ customSocial, socialStories }) => {
  const videoSections = [
    {
      header: 'Custom In-Feed Social',
      subheader:
        'Natively integrate your brand across Barstool’s vast network of social handles, reaching 100+M followers and growing',
      videos: [
        {
          img: 'https://chumley.barstoolsports.com/union/2021/06/18/Screen-Shot-2021-06-18-at-4.17.57-PM.e71e4051.jpg',
          text: 'Custom Meme'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/06/18/Ranking-Graphic_Dunkin-Example-1.5b9ba5e5.jpg',
          text: 'Ranking Graphic'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/06/18/Map-Graphic_Chevy-Example.1b60545b.jpg',
          text: 'Map Graphic'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/06/18/ATI-Question_HBO-Max-Example.d16bad17.jpg',
          text: 'ATI Question'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/06/18/Group-1.fd1c316a.png',
          text: 'Viral Video Alignment'
        },
        {
          videoSource: customSocial,
          text: 'Custom Video (TikTok Only)'
        }
      ],
      render: (videos) => {
        return (
          <div className='socialGrid'>
            {videos.map(({ img, text, videoSource }, idx) => (
              <div key={idx} style={{ backgroundColor: videoSource ? '#fff' : 'transparent' }}>
                {videoSource ? (
                  <div className='socialGrid__video'>
                    <VideoPlayerLite videoSource={mapMediaDocToVideojsObject(videoSource)} aspectRatio={'9:16'} />
                  </div>
                ) : (
                  <img src={img} alt={'social_' + idx} />
                )}
                <h5>{text}</h5>
              </div>
            ))}
            <style jsx>{`
              .socialGrid {
                margin: 30px 0;
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-auto-rows: 1fr;
                grid-column-gap: 10px;
                grid-row-gap: 20px;
              }
              .socialGrid > div {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }
              .socialGrid img {
                width: 100%;
              }
              .socialGrid__video {
                width: 56.25%;
              }
              .socialGrid h5 {
                background: #f5f5f5;
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 0.75rem;
                font-style: italic;
                padding: 8px 0 0;
                margin: 0;
              }
              @media (max-width: ${THEME.BREAKPOINTS.MD}px) {
                .socialGrid h5 {
                  font-size: 0.6rem;
                  padding: 5px 0 0;
                }
              }
              @media (max-width: ${THEME.BREAKPOINTS.XS}px) {
                .socialGrid {
                  grid-template-columns: 1fr;
                  grid-gap: 20px;
                }
                .socialGrid h5 {
                  font-size: 0.8rem;
                  padding: 10px 0 0;
                }
              }
            `}</style>
          </div>
        )
      },
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/twitter.7deabcfc.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/tik_tok.e6c688ff.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/facebook.384e7f8d.png'
      ]
    },
    {
      header: 'Social Stories',
      subheader: 'Social integration within a Barstool or Franchise storyline',
      videos: [
        {
          videoSource: socialStories[0]
        },
        {
          videoSource: socialStories[1]
        },
        {
          videoSource: socialStories[2]
        }
      ],
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/twitter.7deabcfc.png'
      ]
    }
  ]

  return (
    <div className='integrationBottom' style={{ width: '100%' }}>
      {videoSections.map((sectionProps, idx) => (
        <VideoSection key={idx} {...sectionProps} />
      ))}
    </div>
  )
}

const SponsorshipBrandedSocial = (props) => {
  usePageView()

  return (
    <PartnershipsLayout background='#D8D8D8'>
      <SponsorshipSecondary
        title={'BRANDED SOCIAL'}
        details={
          'Natively integrate brands across the Barstool Network of social handles reaching 100M+ followers and growing'
        }
        top={<BrandedSocialTop />}
        bottom={<BrandedSocialBottom {...props} />}
        centerSectionBreak
      />
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  try {
    const customSocial = await MediaStore().findById('dPSXKb9QUkaLemZp3Fb3rd')

    const socialStories = await Promise.all([
      await MediaStore().findById('c1QfdrwDUaXkwZyWLKxC11'),
      await MediaStore().findById('f85LcmPXKTYGmk1gJeB4Qu'),
      await MediaStore().findById('rxMCisPxvNhSNpCXCX9fHC')
    ])

    return { customSocial, socialStories }
  } catch (e) {
    return { customSocial: false, socialStories: false }
  }
})

export default SponsorshipBrandedSocial
